import type { IExtractRouteParamMap } from "../types";
import { createPaths } from "../utils";

// Base route constant
const baseRoute = `/`;

// * Route configuration object for dashboard-related paths.
// ! This object is `readonly` to ensure route parameters are extracted properly.
export const dashboardRoutesObj = {
  home: baseRoute,
} as const;

// * Extracts the route parameters for the dashboard route configuration.
export type IDashboardRouteParams = IExtractRouteParamMap<
  typeof dashboardRoutesObj
>;

// * Path functions for the dashboard routes.
export const dashboardPath = createPaths<
  typeof dashboardRoutesObj,
  IDashboardRouteParams
>(dashboardRoutesObj);
